module.exports = __webpack_public_path__ + "static/img/20240927_1.d974146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240927_1.png
// module id = dUVW
// module chunks = 0